import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import notification from "common/utils/notification"
import { AnimatePresence, motion } from "framer-motion"
import { nanoid } from "nanoid"
import { InputText } from "primereact/inputtext"
import { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import "./inputTags.scss"

const containerTagsVariants = {
  hidden: {
    scale: 0,
  },
  visible: {
    scale: 1,
    transition: {
      type: "tween",
      duration: 0.2,
    },
  },
  exit: {
    scale: 0,
  },
}

const tagVariants = {
  hidden: {
    opacity: 0,
    x: 50,
  },
  visible: {
    x: 0,
    opacity: 1,
    transition: {
      type: "tween",
      duration: 0.2,
    },
  },
  exit: {
    scale: 0,
  },
}

const InputTags = ({
  id,
  isValidTagFn,
  errorMessage = "Tag no válido",
  onChange,
  placeholder,
  tags,
  setTags,
  addTagTrigger = false,
  setAddTagTrigger,
  onAutoSend,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  const [inputTag, setInputTag] = useState("")
  const [showError, setShowError] = useState(false)

  const tagIsValid = () => {
    if (!tags.length && !inputTag.length) {
      notification.errorServidor({
        body: `${t("notification.noEmails")}`,
      })
      return
    }

    if (!inputTag) return true

    const isValidTag =
      typeof isValidTagFn === "function" ? isValidTagFn(inputTag) : true
    setShowError(!isValidTag)

    const existElement = tags.some(
      (option: $TSMigrationFixMe) => option.text === inputTag
    )

    return isValidTag && !existElement
  }

  const handleAddTag = (autosend = false) => {
    if (tagIsValid()) {
      const tag = {
        id: nanoid(),
        text: inputTag,
      }
      setTags((prevTags: $TSMigrationFixMe) => {
        const newTags = [...prevTags, ...(inputTag ? [tag] : [])]
        onChange(newTags)
        if (autosend) onAutoSend(newTags)
        return newTags
      })
      setInputTag("")
    }
  }

  const handleDelete = (id: $TSMigrationFixMe) => {
    setTags((prevTags: $TSMigrationFixMe) => {
      const newTags = prevTags.filter((tag: $TSMigrationFixMe) => tag.id !== id)
      onChange(newTags)
      return newTags
    })
  }

  const controllerInputText = (ev: $TSMigrationFixMe) => {
    const keyTriggers = ["Enter", " ", ";"]
    const keyTriggersEnter = ["Enter"]
    if (keyTriggersEnter.includes(ev.key)) {
      ev.stopPropagation()
      ev.preventDefault()
    }
    if (keyTriggers.includes(ev.key)) {
      handleAddTag()
    }
  }

  const cleanSpaces = (value: $TSMigrationFixMe) =>
    value.replace(" ", "").trimEnd().trimStart()

  const isNotTriggerKey = (value: $TSMigrationFixMe) =>
    value !== " " && value !== ";"

  useEffect(() => {
    if (addTagTrigger) {
      handleAddTag(true)
      setAddTagTrigger(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addTagTrigger])

  return (
    <div className='wrap-input-tags'>
      <>
        <div className='p-input-icon-right'>
          <InputText
            className={`w-100 ${showError ? "p-invalid p-d-block" : ""}`}
            onChange={({ target: { value } }) => {
              // @ts-expect-error TS(2774): This condition will always return true since this ...
              if (isNotTriggerKey) {
                setInputTag(cleanSpaces(value))
              }
            }}
            value={inputTag}
            onKeyPress={(ev) => {
              controllerInputText(ev)
            }}
            id={id}
            placeholder={placeholder}
          />
          <FontAwesomeIcon
            className='icon-plus'
            icon={["fal", "circle-plus"]}
            onClick={() => handleAddTag(false)}
          />
        </div>
        {showError && (
          <small className='p-error p-d-block'>{errorMessage}</small>
        )}
      </>

      <AnimatePresence>
        {tags.length && (
          <motion.div
            variants={containerTagsVariants}
            initial='hidden'
            animate='visible'
            exit='exit'
            className='tags-container'
          >
            <AnimatePresence>
              {tags.map((tag: $TSMigrationFixMe) => (
                <motion.div
                  variants={tagVariants}
                  initial='hidden'
                  animate='visible'
                  exit='exit'
                  key={tag.id}
                  className='tag-item'
                >
                  {tag.text}
                  <FontAwesomeIcon
                    icon={["fal", "xmark"]}
                    onClick={() => handleDelete(tag.id)}
                    className='icon-delete'
                  />
                </motion.div>
              ))}
            </AnimatePresence>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  )
}

export default InputTags
